"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

// Fires only when the ROOT LAYOUT itself throws. Deliberately self-contained:
// no app components, no Tailwind classes, no providers — whatever crashed the
// root layout may be exactly those modules, and global CSS may not have loaded.
const GlobalError = ({ error }) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          color: "#131517",
          background: "#ffffff"
        }}
      >
        <div style={{ textAlign: "center", padding: 24 }}>
          <h2 style={{ margin: "0 0 8px", fontSize: 20, fontWeight: 600 }}>
            Something went wrong!
          </h2>
          <p style={{ margin: "0 0 20px", fontSize: 14, color: "#6E6C75" }}>
            Please try again. If the problem continues, refresh the page.
          </p>
          <button
            type="button"
            // Full reload, NOT reset(): reset() re-mounts the root App Router,
            // and Next 14 nulls its initial parallel-routes cache after the
            // first mount — so a re-mount throws "Cannot read properties of
            // null (reading 'get')" and lands right back here, every click.
            onClick={() => window?.location?.reload()}
            style={{
              background: "#333333",
              color: "#ffffff",
              fontSize: 16,
              border: "none",
              borderRadius: 8,
              padding: "8px 40px",
              cursor: "pointer"
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
};

export default GlobalError;
